import React from "react";
import i18next from "i18next";

import {authRoles} from "../../auth/index.js";
import en from "./i18n/en.js";

i18next.addResourceBundle("en", "photos", en);

const HomeConfig = {
  settings: {layout: {config: {}}},
  auth: authRoles.user,
  routes: [
    {
      path: "/photos",
      exact: true,
      component: React.lazy(() => import("./photos.js")),
    },
  ],
};

export default HomeConfig;
